import { useContext } from 'react';

import { Icon, IconButton } from '@atom/mui';
import { GrantType, PolicyResource } from '@atom/types/policy';

import PolicyModalContext from './PolicyModalContext';

interface Props {
  title: string;
}

const PolicyModalTitle = ({ title }: Props) => {
  const { state, updateState } = useContext(PolicyModalContext);

  const toTitle = (name: string) => {
    return (
      <>
        <IconButton onClick={() => updateState({ view: 'MAIN' })}>
          <Icon>arrow_back</Icon>
        </IconButton>
        {name}
      </>
    );
  };

  const getTitle = () => {
    switch (state.view) {
      case PolicyResource.INVENTORY_FOLDER: {
        return toTitle('Select Inventory Folder(s)');
      }
      case PolicyResource.INVENTORY_ITEM: {
        return toTitle('Select Inventory Item(s)');
      }
      case PolicyResource.WORK_TYPE_FOLDER: {
        return toTitle('Select Work Template Folder(s)');
      }
      case PolicyResource.ANALYTICS_FOLDER: {
        return toTitle('Select Analytics Folder(s)');
      }
      case PolicyResource.BUDGETING_APPROVAL:
      case PolicyResource.BUDGETING_UNIT: {
        return toTitle('Select Budget Unit(s)');
      }
      case GrantType.USER_GROUP: {
        return toTitle('Select User Group(s)');
      }
      default:
        return <span>{title}</span>;
    }
  };

  return getTitle();
};

export default PolicyModalTitle;
